import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  href: "#",
  "aria-label": "Scroll to top",
  class: "min-w-fit rounded-md"
}
const _hoisted_2 = ["src", "alt"]

import { BlockDescriptiveImage } from "@/views/blocks/PageBlock.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoComponent',
  props: {
    alt: {},
    src: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _createElementVNode("img", {
      class: "h-8 w-auto",
      src: _ctx.src,
      alt: _ctx.alt
    }, null, 8, _hoisted_2)
  ]))
}
}

})